import { Link, useLocation } from 'react-router-dom';
import { CreditCard, BarChart3, Sparkles, Heart, Settings, Menu, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { useState } from 'react';

const links = [
  { to: '/', label: 'Credit Cards', icon: CreditCard },
  { to: '/compare', label: 'Compare', icon: BarChart3 },
  { to: '/recommend', label: 'AI Advisor', icon: Sparkles },
  { to: '/favorites', label: 'Saved', icon: Heart },
];

export default function Navbar() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const isAdmin = !!localStorage.getItem('adminToken');

  const NavLinks = ({ onClick, vertical }) => (
    <div className={vertical ? 'flex flex-col gap-1' : 'flex items-center gap-0.5'}>
      {links.map(link => {
        const Icon = link.icon;
        const active = location.pathname === link.to;
        return (
          <Link
            key={link.to}
            to={link.to}
            onClick={onClick}
            data-testid={`nav-${link.label.toLowerCase().replace(/\s/g, '-')}`}
            className={`flex items-center gap-2 px-3.5 py-2 rounded-full text-[13px] font-medium transition-all duration-200 ${
              active
                ? 'bg-[#002FA7] text-white shadow-sm'
                : 'text-[#52525B] hover:text-[#09090B] hover:bg-[#F4F4F5]'
            }`}
          >
            <Icon className="w-3.5 h-3.5" />
            {link.label}
          </Link>
        );
      })}
      <Link
        to={isAdmin ? '/admin' : '/admin/login'}
        onClick={onClick}
        data-testid="nav-admin"
        className={`flex items-center gap-2 px-3.5 py-2 rounded-full text-[13px] font-medium transition-all duration-200 ${
          location.pathname.startsWith('/admin')
            ? 'bg-[#002FA7] text-white shadow-sm'
            : 'text-[#52525B] hover:text-[#09090B] hover:bg-[#F4F4F5]'
        }`}
      >
        <Settings className="w-3.5 h-3.5" />
        Admin
      </Link>
    </div>
  );

  return (
    <nav data-testid="main-navbar" className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-[#E4E4E7]">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-[#002FA7] flex items-center justify-center">
            <CreditCard className="w-4.5 h-4.5 text-white" />
          </div>
          <div className="flex items-baseline gap-1.5">
            <span className="font-heading font-bold text-lg text-[#09090B] tracking-tight">CardCompare</span>
            <span className="text-[10px] font-bold text-[#002FA7] bg-[#EEF2FF] px-1.5 py-0.5 rounded tracking-wider">UAE</span>
          </div>
        </Link>

        <div className="hidden md:block">
          <NavLinks />
        </div>

        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild className="md:hidden">
            <Button variant="ghost" size="icon" data-testid="mobile-menu-btn">
              <Menu className="w-5 h-5" />
            </Button>
          </SheetTrigger>
          <SheetContent side="right" className="w-72 pt-12">
            <NavLinks onClick={() => setOpen(false)} vertical />
          </SheetContent>
        </Sheet>
      </div>
    </nav>
  );
}
